module.exports = function roundToTwoDecimalPlaces(number) {
    return Math.round(number * 100) / 100
}
